import { TextShow } from 'Utils/Helpers/TextShow';
import * as icons from 'react-bootstrap-icons';
import Header from '../Header';
import NewType from './new';
import ListTypes from './list';

const title = 'نوع‌ها';

export default function SetTypes() {
  return (
    <>
      <Header title={title} justText />
      <div className='mt-4'>
        <TextShow
          title={"تنظیم انواع نوبت در مطب"}
          icon={<icons.Fingerprint size={18} />}
          justText
          className={'no-hide text-muted'}
        />
        <div className='setting-app-types'>
          <NewType />
          <ListTypes />
        </div>
      </div>
    </>
  );
}